<template>
  <div class="agreement-table">
    <vxe-toolbar size="mini">
      <template
        v-slot:buttons
        v-if="
          contractStatus == '' ||
          contractStatus == 'ZT06' ||
          contractStatus == 'ZT05' ||
          contractStatus == 'ZT061' ||
          contractStatus == 'ZT051' ||
          copyState
        "
      >
        <el-button
          type="primary"
          size="small"
          class="vxe-btn-primary"
          @click="$refs.xTableRef.commitProxy('insert_actived')"
          >新增</el-button
        >
        <el-button
          size="small"
          type="danger"
          class="vxe-btn-delete"
          @click="deleteBtnClickHandler()"
          >删除</el-button
        >
      </template>
    </vxe-toolbar>
    <!---可编辑表格-->
    <vxe-grid
      border
      size="mini"
      align="center"
      show-overflow
      show-header-overflow
      ref="xTableRef"
      class="vxe-table-element"
      resizable
      show-footer
      :auto-resize="true"
      :data="tableData"
      height="300"
      :edit-rules="tableRule"
      :edit-config="
        contractStatus == 'ZT02' || contractStatus == 'ZT03' || copyState
          ? {}
          : { trigger: 'click', mode: 'row' }
      "
      @edit-closed="closeEditTableHandler"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
      :valid-config="{ autoPos: true, message: 'inline' }"
    >
      <template v-slot:buttons>
        <el-button @click="newRowHandler" size="small" type="primary" class="vxe-btn-primary"
          >新增行</el-button
        >
        <el-button @click="deleteBtnClickHandler" size="small" type="danger" class="vxe-btn-delete"
          >删除</el-button
        >
      </template>
      <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
      <vxe-table-column type="seq" title="序号" width="80"></vxe-table-column>
      <!-- <vxe-table-column type="seq" title="行项目号" width="100"></vxe-table-column> -->
      <vxe-table-column
        v-for="(item, index) in tableColumns"
        :key="index"
        :type="item.type"
        :fixed="item.fixed"
        :field="item.field"
        :title="item.title"
        :width="item.width"
        :visible="item.visible"
        :sortable="item.sortable"
        :edit-render="item.editRender"
      >
        <template v-slot="{ row }">
          <template v-if="item.field == 'isFixedPrice'">
            <span>{{ row[item.field] == '0' ? '否' : '是' }}</span>
          </template>
          <template v-else-if="item.field == 'unit'">
            <span>{{ row['unitName'] }}</span>
          </template>
          <span v-else>{{ row[item.field] }}</span>
        </template>
        <template v-slot:edit="{ row }">
          <!-- 合同标的 -->
          <search-table
            v-if="item.editRender?.name == 'contractMatterName'"
            v-model="row[item.field]"
            searchType="usableProduct"
            :isMultiple="true"
            :disabled="contractStatus == 'ZT02' || contractStatus == 'ZT03'"
            :extraData="{
              parentProductStatus: 'ZT03',
              contractCategory: $route.query.contractCategory == 'sales' ? 'sales' : 'purchase',
              adminFlag: 2,
              selectCompanyCode: companyCode,
              businessCompanyCodeList: companyList,
            }"
            :currentValue="row[item.field]"
            @input="(val) => chooseTable(val, row, item.field)"
          ></search-table>
          <!-- 是否定价 -->
          <el-select
            v-if="item.editRender?.name == 'isFixedPrice'"
            filterable
            clearable
            v-model="row[item.field]"
            :disabled="contractStatus == 'ZT02' || contractStatus == 'ZT03'"
            @change="() => handleChange(row, item.field)"
          >
            <el-option :value="1" label="是"></el-option>
            <el-option :value="0" label="否"></el-option>
          </el-select>
          <!-- 单位 -->
          <el-input v-if="item.editRender?.name == 'unit'" v-model="row.unitName" disabled>
          </el-input>
          <!-- 交货数量 -->

          <input-number-ad
            v-if="item.editRender?.name == 'productQuantity'"
            maxlength="99999999999999"
            v-model="row[item.field]"
            :disabled="contractStatus == 'ZT02' || contractStatus == 'ZT03'"
            max="99999999999"
            :precision="Number(6)"
            :controls="false"
          />
        </template>
      </vxe-table-column>
    </vxe-grid>
  </div>
</template>

<script>
  import { baseColumnList, baseTableRule } from './index.js';
  import inputNumberAd from '@/components/form-item/input-number-advance';
  import contractComputedMixin from './../../contractComputedMixin.js';
  import API from '@/api/dataBase.js';

  export default {
    name: 'ShopDetailAgreementTable',
    mixins: [contractComputedMixin],
    data() {
      return {
        selectionList: [],
        tableData: [],
        companyCode: '',
        companyList: [],
      };
    },
    props: {
      orderDetailList: {
        type: Array,
        default: () => [],
      },
      contractStatus: {
        type: String,
        default: () => '',
      },
      baseFormData: {
        type: Object,
      },
    },
    components: {
      inputNumberAd,
    },
    computed: {
      tableColumns() {
        return baseColumnList(this);
      },
      tableRule() {
        return baseTableRule(this);
      },
      copyState() {
        console.log('copyState', this.$route.query.isCopy);
        return this.$route.query.isCopy;
      },
    },
    mounted() {
      this.getCompany();
    },
    methods: {
      // 获取当前登陆人下面的所有公司数据
      async getCompany() {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        this.$axios.post(API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            // 获取公司下拉
            let companyList = res.data.data.personCompanyInfo || [];
            this.companyList = companyList.map((item) => {
              return item?.personCompanyCode;
            });
          }
        });
      },
      // 正常编辑的选中
      handleChange(row, field) {
        console.log(row, field, '行');
        // if (field == 'isFixedPriceName') {
        //   row['isFixedPriceName'] = row['isFixedPriceName'] == 1 ? '是' : '否';
        //   row['isFixedPrice'] = row['isFixedPriceName'];
        // }
        if (
          field === 'businessContractUnitPrice' ||
          field === 'productQuantity' ||
          field == 'taxRate'
        ) {
          row['businessContractTotalAmount'] = this.computedBusinessContractTotalAmount(row); // 价税合计金额
        }
      },
      chooseTable(val, row, field) {
        console.log(val, row, field);
        if (field == 'contractMatterName') {
          // 合同标
          const rowData = val[0];
          let product = rowData;
          row['contractMatterName'] = rowData?.productChName;
          if (product?.productDetailCode && product?.productDetailCode.length != 0) {
            row['contractMatter'] = product?.productDetailCode;
          } else {
            row['contractMatter'] = product?.parentProductNo;
          }

          //如果没有选产品 则不走下面的逻辑
          if (product) {
            console.log(product.businessContractTaxAmount, '税额');
            row.productNo = product.parentProductNo;
            row.productDesc = product.detailProductModel;
            row.taxCode = product.salesTaxCode;
            row.taxName = row.taxCode
              ? this.addedTaxRateOptions?.find((options) => {
                  return row.taxCode == options.taxCode;
                }).taxName
              : '';
            row.taxRate = product.salesTaxRate || 0;
            // 进口普通关税率
            row.importNormalTariffRate = product.importNormalTariffRate || 0;
            row.unit = product.basicUnit || null;
            row.unitName = product.basicUnitName || null;
            row['businessContractTotalAmount'] = this.computedBusinessContractTotalAmount(row); // 价税合计金额
          }
        }
      },
      // 删除
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));

        // 判断当前删除中是否有id
        const idList = this.selectionList.map((item) => item.id);

        // 删除的id数据传给父
        this.$emit('tableDeleteNotifier', idList);
        this.$emit('closeTableHandler', this.tableData);
      },
      // 选择行
      handleSelectionChange(row) {
        this.selectionList = row.selection;
      },
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.xTableRef;
        return $table.getTableData().fullData;
      },
      // 关闭的时候数据校验
      async closeEditTableHandler() {
        const $table = this.$refs.xTableRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          this.$message.error('请检查数据再提交');
        } else {
          await $table.clearActived();
          this.$emit('closeTableHandler', this.getTableData());
        }
      },
      // 反填数据到表格中
      fullTableData(val) {
        if (val && Array.isArray(val) && val.length) {
          const $table = this.$refs.xTableRef;
          $table.insertAt(val, 0);
        }
      },
    },
    watch: {
      orderDetailList: {
        handler(val) {
          this.fullTableData(val);
        },
        immediate: true,
        deep: true,
      },
      baseFormData: {
        handler(val) {
          console.log(val, '监听');
          this.companyCode = val.companyCode ?? this.userInfo.companyCode;
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
